const departurePlaces = {
  school: 135,
  providerOffice: 136,
  csse: 137,
  home: 482,
};

export default departurePlaces;
